import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Carrusel from '../components/Carrusel';
import Map from '../components/Google-Maps/Map'; // Asegúrate de que la ruta sea correcta
import '../assets/styles/Home.css';
import NoticiasDestacadas from './featured-news/NoticiasDestacadas';
import AdmissionModal from '../components/AdmissionModal';

function Home() {
  return (
    <div className="home-page animated fadeIn">
      <Helmet>
        <title>Colegio Cristiano Le Beau Jour | Educación con valores en Viña del Mar</title>
        <meta
          name="description"
          content="Colegio Cristiano Le Beau Jour en Viña del Mar. Educación con valores cristianos, enseñanza personalizada y más de 40 años de trayectoria. Matrículas abiertas a través del MINEDUC."
        />
        <link rel="canonical" href="https://www.colegiocristianolebeaujour.cl/" />
      </Helmet>

      <AdmissionModal />

      <div className="home-container">
        <h1 className="home-title">LE BEAU JOUR</h1>
        <h2 className="home-subtitle">EDUCANDO AL ABRIGO DEL ALTÍSIMO</h2>
        <Link to="/contacto" className="home-button">
          Contáctanos
        </Link>
      </div>
      <Carrusel />
      <NoticiasDestacadas />

      <section className="location-section">
        <div className="location-content">
          <h1 className="location-title">Nuestra Ubicación</h1>
          <div className="location-details">
            <h2 className="location-subtitle">Encuéntranos en:</h2>
            <p className="location-address">23 Norte Calle Dos, 2039 - Viña del Mar</p>
          </div>
          <div className="location-map">
            <Map />
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
